/*
 * Copyright (c) 2024.
 * The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 *
 */

import Dates from "utils/Dates";
import {Package} from "types/entities/Package";
import {useTranslation} from "react-i18next";
import {PackageCategory} from "../types/enums/PackageCategory";

export const moduloMinutesForFakeTimeslots = timeslot => {
    return Dates.hour(timeslot.start_at) + ":" + (Dates.minute(timeslot.start_at) >= 30 ? "30" : "00");
};

export const useGetRaceNamesByTimeslotsAndPackage = (index: number, Package: Package | null) => {
    const {t} = useTranslation();

    if (Package && Package.category === PackageCategory.Event) {
        return t("Reservation time");
    }

    // switch (index) {
    //     case 0:
    //         return t("First heat");
    //     case 1:
    //         return t("Second heat");
    //     case 2:
    //         return t("Third heat");
    //     case 3:
    //         return t("Fourth heat");
    //     case 4:
    //         return t("Fifth heat");
    //     default:
    //         return t("Reservation time");
    // }

    switch (index) {
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return t("Race");
        default:
            return t("Reservation time");
    }
};

export const useGetAccessNamesByTimeslotsAndPackage = (index: number, Package: Package | null) => {
    const {t} = useTranslation();

    if (Package && Package.category === PackageCategory.Event) {
        return t("Reservation time");
    }

    switch (index) {
        case 0:
            return t("Start");
        default:
            return t("End");
    }
};
